export default __webpack_public_path__ + "static/media/pin.4ffdcba2.svg";